/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Answer_0Inputs */

const en_help_center__payments_n_refunds__answer_0 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Answer_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We accept all major debit cards, iDEAL- WERO (for Netherlands), Bancontact (for Belgium), PayPal, and Apple Pay/Google Pay. All transactions are secured with 256-bit SSL encryption.`)
};

/**
* | output |
* | --- |
* | "We accept all major debit cards, iDEAL- WERO (for Netherlands), Bancontact (for Belgium), PayPal, and Apple Pay/Google Pay. All transactions are secured with..." |
*
* @param {Help_Center__Payments_N_Refunds__Answer_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__answer_0 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Answer_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Answer_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__answer_0(inputs)
});